import { render, staticRenderFns } from "./segmentatie.vue?vue&type=template&id=81536822&scoped=true"
import script from "./segmentatie.vue?vue&type=script&lang=js"
export * from "./segmentatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81536822",
  null
  
)

export default component.exports